import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { PrivatePageLayout, PageHeader, PageTableCard } from '../../components/PrivatePage';
import SearchSymbol from '../../components/SearchSymbol/SearchSymbol';
import NewOrderTemplateButton from './NewOrderTemplateButton';
import OrderTemplateRow from './OrderTemplateRow';
import { getOrderTemplates, deleteOrderTemplate } from '../../services/OrderTemplatesService';
import Pagination from '../../components/Pagination/Pagination';
import Toast from '../../components/Toast/Toast';
import SpotFuturesToggle from '../../components/SpotFuturesToggle/SpotFuturesToggle';

function OrderTemplates() {

    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    const history = useHistory();

    useEffect(() => {
        return history.listen((location) => {
            setPage(getPage(location));
        })
    }, [history])

    const { symbol } = useParams();

    const [search, setSearch] = useState(symbol ? symbol : '');
    const [refresh, setRefresh] = useState(0);
    const [orderTemplates, setOrderTemplates] = useState([]);

    const [notification, setNotification] = useState([]);

    const [count, setCount] = useState(0);

    const [page, setPage] = useState(getPage());

    const [showSpot, setShowSpot] = useState(true); // New state for spot data
    const [showFutures, setShowFutures] = useState(false); // New state for future data

    useEffect(() => {
        getOrderTemplates(search, page || 1, showFutures)
            .then(result => {
                setOrderTemplates(result.rows ? result.rows : []);
                setCount(result.count);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            })

    }, [search, page, refresh, showFutures])

    function onSearchChange(event) {
        setSearch(event.target.value);
    }

    function onDeleteClick(event) {
        const id = event.target.id.replace('delete', '');
        deleteOrderTemplate(id)
            .then(template => { history.go(0) })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message)
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }

    useEffect(() => {
        if (showSpot) {
            history.push('/orderTemplates/');
        } else {
            history.push('/fOrderTemplates/');
        }
    }, [showSpot, history])

    const headerActions = (
        <>
            {localStorage.getItem("hasFutures") === "true" ? (
                <SpotFuturesToggle
                    value={showFutures ? 'futures' : 'spot'}
                    onChange={(market) => {
                        setShowSpot(market === 'spot');
                        setShowFutures(market === 'futures');
                    }}
                />
            ) : null}
            <NewOrderTemplateButton />
            <SearchSymbol onChange={onSearchChange} placeholder={search} />
        </>
    );

    return (
        <React.Fragment>
            <PrivatePageLayout>
                <PageHeader
                    eyebrow="Currently running"
                    title={`${showFutures ? 'Futures' : 'Spot'} order templates`}
                    subtitle="Reusable order configurations linked to your automations."
                    actions={headerActions}
                />
                <PageTableCard>
                    <div className="table-wrapper table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="border-gray-200">Symbol</th>
                                    <th className="border-gray-200">Name</th>
                                    <th className="border-gray-200">Side</th>
                                    <th className="border-gray-200">Type</th>
                                    <th className="border-gray-200">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderTemplates && orderTemplates.length
                                    ? orderTemplates.map((ot) => (
                                        <OrderTemplateRow key={ot.id} data={ot} onDeleteClick={onDeleteClick} />
                                    ))
                                    : null}
                            </tbody>
                        </table>
                    </div>
                    <Pagination count={count} />
                </PageTableCard>
            </PrivatePageLayout>
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default OrderTemplates;
